import React, {useRef, useEffect} from "react";
import classes from './profileMenu.module.css';
import { NavLink } from "react-router-dom";
import Profile from '../../../../assets/images/profile.png';
import { X } from "lucide-react";
import Logout from '../../../../assets/images/Out.svg';
import Close from '../../../../assets/images/X.png'
function ProfileMenu(props) {
    const logoutClickHandler = () => {
        props.onLogout();
        props.setShowProfileMenu(false);
        props.navigate('/');
    }
    const profileMenuRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
          if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
            props.setShowProfileMenu(null);
          }
        };
        document.addEventListener('mousedown', handleClickOutside);
    
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, []);
    const Content = () => {
        return (
        <div className={classes.Content}>
            <div>
                <div className={classes.UserData}>
                    <img src={props.profileImg} alt="Profile" />
                    <div>
                        <span className={classes.Name}>{props.user?.basic_info?.full_name}</span>
                        <span className={classes.Email}>{props.user?.basic_info?.email}</span>
                    </div>
                </div>
                <span className={classes.Points}>You have <span>{props.user?.loyalty?.points} JD</span> from loyalty program</span>
            </div>
            <div className={classes.NavigationLinks}>
                <NavLink className={classes.NavLink} to='/profile/account' onClick={() => props.setShowProfileMenu(false)}>My Account</NavLink>
                <NavLink className={classes.NavLink} to='/profile/activities' onClick={() => props.setShowProfileMenu(false)}>My Activities</NavLink>
                <NavLink className={classes.NavLink} to='/profile/signed-documents' onClick={() => props.setShowProfileMenu(false)}>Signed Documents</NavLink>
                <div className={classes.ReceiveNotifications}>
                    <span>Receive Notifications</span>
                    <button><span></span></button>
                </div>
                <NavLink className={classes.NavLink} to='/profile/change-password' onClick={() => props.setShowProfileMenu(false)}>Change Password</NavLink>
                <div className={classes.Logout} onClick={logoutClickHandler}>
                    <img src={Logout} alt='logout' />
                    <span>Logout</span>
                </div>
            </div>
        </div>
        )
    }


    return (
        <div className={`${classes.ProfileMenu} ${props.showProfileMenu && classes.ProfileMenuOpen}`}
        ref={profileMenuRef}>
            <div onClick={() => props.setShowProfileMenu(false)}>
                <X className={classes.CloseIcon} />
                <img className={classes.CloseImg} src={Close} alt="close"/>
            </div>
            {props.width < 1024 ?<div className={classes.RedBorder}>
                <div className={classes.BlueBorder}>
                    <div className={classes.WhiteBorder}>
                        <Content />
                    </div>
                </div>
            </div> : <Content/>}
        </div>
    );
}

export default ProfileMenu;